import React from "react";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { badgeDisplay, idbPromise } from "../../utils/helpers";
import { useDispatch } from "react-redux";
import { DELETE_TASK } from "../../utils/actions";

export default function TaskDetails({ task, showDetail, setShowDetail, setShowEditor, setEditTask }) {
    const dispatch = useDispatch();

    const statusDisplay = (status) => {
        if (status === "todo") {
            return "TO DO"
        };
        return status.toUpperCase();
    }
    const handleEdit = () => {
        setShowDetail(false);
        setShowEditor(true);
        setEditTask(task);
    };

    const handleDelete = () => {
        idbPromise("tasks", "delete", task);
        dispatch({
            type: DELETE_TASK,
            id: task.id
        });
        setShowDetail(false);
    };

    return (
        <Modal
            show={showDetail}
            onHide={() => setShowDetail(false)}
            dialogClassName="modal-90w"
            aria-labelledby="custom-modal-styling-title"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {task.title}
                </Modal.Title>
                <Badge 
                    bg={task.status === "done" ? "primary" : badgeDisplay(task.deadline)} 
                    style={{ marginLeft: "auto" }} 
                    pill
                >
                    {task.deadline}
                </Badge>
                <Badge bg="primary" style={{ marginLeft: "auto" }}>
                    STATUS: {statusDisplay(task.status)}
                </Badge>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {task.details}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleEdit} className="primary-button" variant="primary">Edit</Button>
                <Button
                    onClick={handleDelete}
                    className="primary mt-2 text-centre primary-button"
                >
                    DELETE
                </Button>
            </Modal.Footer>
        </Modal>
    );
};